import { render, staticRenderFns } from "./OddNumber.vue?vue&type=template&id=1bd1e4ca&scoped=true&"
import script from "./OddNumber.vue?vue&type=script&lang=js&"
export * from "./OddNumber.vue?vue&type=script&lang=js&"
import style0 from "./OddNumber.vue?vue&type=style&index=0&id=1bd1e4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd1e4ca",
  null
  
)

export default component.exports